
import { HttpHeaders } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { AvisoStorage, BaseResourceService } from 'eddydata-lib';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AvisoStorageService extends BaseResourceService<AvisoStorage> {

  constructor(
    protected injector: Injector
  ) {
    super(`aviso-storages`, injector);
  }


  public upload(arquivos: any[], orgao: number, aviso: number, descricao?: string): Observable<AvisoStorage[]> {
    const formData = new FormData();
    for (let arquivo of arquivos) {
      formData.append('files', arquivo);
    }
    if (descricao) {
      formData.append('descricao', descricao);
    }

    const headers = this.httpOptions();
    headers.headers = headers.headers.delete('Content-Type');

    return this.http.post<AvisoStorage[]>(`${this.login.cidade.id}/${this.api}/upload-aviso/${orgao}/${aviso}`,
      formData, headers)
      .pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public removerTodos(aviso: number): Observable<any> {
    return this.http.post(`${this.login.cidade.id}/${this.api}/remover-todos-aviso/${aviso}`, {}, this.httpOptions())
      .pipe(
        map(res => res),
        catchError(err => this.handleError(err)));
  }

  public visuTransparenciaTodos(aviso: number, visualizacao: boolean): Observable<any> {
    return this.http.post(`${this.login.cidade.id}/${this.api}/visualizar-todos-aviso/${aviso}/${visualizacao}`, {}, this.httpOptions())
      .pipe(
        map(res => res),
        catchError(err => this.handleError(err)));
  }

  public baixarTodos(aviso: number): Observable<any> {
    return this.http.get<any>(`${this.login.cidade.id}/${this.api}/download-todos-aviso/${aviso}`, this.httpOptions())
      .pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public downloadZip(): Observable<any> {
    return this.http.get<any>(`${this.login.cidade.id}/${this.api}/download-zip-aviso`, {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders(this.adicionarCriptografia({
        Authorization: this.login.token,
      }))
    }).pipe(
      map(res => res),
      catchError(err => this.handleError(err))
    );
  }

}